import { render, staticRenderFns } from "./_MethodBlock.vue?vue&type=template&id=44839b3a&scoped=true&"
import script from "./_MethodBlock.vue?vue&type=script&lang=js&"
export * from "./_MethodBlock.vue?vue&type=script&lang=js&"
import style0 from "./_MethodBlock.vue?vue&type=style&index=0&id=44839b3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44839b3a",
  null
  
)

export default component.exports